import {Context, createContext} from 'solid-js'
import {ToastProviderBehavior} from "./ToastProvider";

export const ToastContext: Context<ToastProviderBehavior> = createContext({
    show: () => undefined,
})
